export const LEARN_CHAPTER_ORDER = [
  'introduction',
  'opentelemetry-fundamentals',
  'language-and-frameworks',
  'databases-caches-and-messaging',
  'infrastructure-cloud-and-ci-cd',
  'llms-ai-and-ml',
  'best-practices',
  'misc',
  'comparisons',
]
